var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-title",class:("status--" + _vm.status)},[_c('span',{staticClass:"status-icon",class:_vm.statusIcon}),_c('span',{staticClass:"item-label",domProps:{"innerHTML":_vm._s(_vm.label)}})])}
var staticRenderFns = []

export { render, staticRenderFns }